/* eslint-disable no-unused-vars */

/* eslint-disable react/prop-types */

/* eslint-disable semi */

/* Import */
import React, { Component } from 'react';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import MetaTags from 'react-meta-tags';
import { connect } from 'react-redux';
import { safeDeepGet } from 'iotera-base/utility/json';
import CryptoJS from 'crypto-js'; // pastikan terinstal
import { Button } from 'reactstrap';
import { isMobile } from 'react-device-detect';

import Result from 'iotera-base/result';
import { safeGet } from 'iotera-base/utility/json';
import { Html5Qrcode } from 'html5-qrcode';

import {
  get_device_id,
  link_merchant_id,
} from '../../store/business-point/actions';

import 'tippy.js/dist/tippy.css';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { NAVBAR } from 'Apps';
import Pages403 from '../pages-403';
const drole = localStorage.getItem('accessNav');
const jsonRole = JSON.parse(drole);

class ScanQRCode extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      modal: false,
      modalNav: false,
      Role: [],
      isLoading: false,
      uid: '',
      merchantId: '',
      deviceId: '',
      scanMode: null, // "uid" | "merchant"
      isScanning: false,
    };
    this.qrScanner = null;
    this.videoRegionId = 'qr-reader';
    this.scannerRef = React.createRef();
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    // this.props.GetDeviceId({uid:"005224600c94"});
    // this.setState({
    //   isScanning: false,
    //   merchantId: 'G2323223',
    //   uid: '232323',
    //   deviceId: '323232',
    // });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.getDeviceResult !== prevProps.getDeviceResult) {
      // Success create
      const code = safeDeepGet(this.props, ['getDeviceResult', 'code'], null);
      if (code !== null) {
        if (code === Result.SUCCESS || code === Result.HTTP.OK) {
          const body = safeDeepGet(this.props, ['getDeviceResult', 'body'], {});
          this.setState({
            isScanning: false,
            deviceId: safeDeepGet(body, 'device_id', ''),
          });
          this.showToast(
            'Device ID ditemukan: ' + safeDeepGet(body, 'device_id', ''),
            'success'
          );
        } else {
          this.showToast('Device ID Tidak ditemukan', 'error');
        }
      }
    }
    if (this.props.linkResult !== prevProps.linkResult) {
      // Success create
      const code = safeDeepGet(this.props, ['linkResult', 'code'], null);
      if (code !== null) {
        if (code === Result.SUCCESS || code === Result.HTTP.OK) {
          const body = safeDeepGet(this.props, ['linkResult', 'body'], {});
          this.showToast(
            `UID: ${this.state.uid} dan Merchant ID ${this.state.merchantId} Berhasil di Link`,
            'success'
          );
          this.setState({
            isLoading: false,
            merchantId: '',
            uid: '',
            deviceId: '',
          });
        } else {
          this.showToast('Gagal Linking Merchant id', 'error');
          this.setState({
            deviceId: '',
          });
        }
      }
    }
  }
  componentWillUnmount() {
    this.stopScanner();
  }

  startScanner(mode) {
    if (this.state.isScanning) {
      this.stopScanner();
    }

    this.setState({ scanMode: mode, isScanning: true }, () => {
      this.qrScanner = new Html5Qrcode(this.videoRegionId);
      Html5Qrcode.getCameras().then(devices => {
        // if (devices && devices.length) {
        //   const frontCamera =
        //     devices.find(d =>
        //       d.label.toLowerCase().includes('front') ||
        //       d.label.toLowerCase().includes('webcam')
        //     ) || devices[0]; // fallback ke kamera pertama

        //   this.qrScanner
        //     .start(
        //       frontCamera.id,
        //       {
        //         fps: 10,
        //         qrbox: 250,
        //       },
        //       this.onScanSuccess.bind(this),
        //       error => console.warn('Scan error:', error)
        //     )
        //     .catch(err => console.error('Start scan error:', err));
        // }
        if (devices && devices.length) {
          const backCamera =
            devices.find(d => d.label.toLowerCase().includes('back')) ||
            devices[0];

          this.qrScanner
            .start(
              backCamera.id,
              {
                fps: 10,
                qrbox: 350,
              },
              this.onScanSuccess.bind(this),
              error => console.warn('Scan error:', error)
            )
            .catch(err => console.error('Start scan error:', err));
        }
      });
    });
  }

  stopScanner() {
    if (this.qrScanner) {
      this.qrScanner
        .stop()
        .then(() => {
          this.qrScanner.clear();
          this.qrScanner = null;
          this.setState({ isScanning: false });
        })
        .catch(err => console.error('Stop scan error:', err));
    }
  }
  parseEmvQrData(data) {
    const match = data.match(/G\d{9}/);
    if (match) {
      this.showToast('Ditemukan: ' + match[0], 'success'); // Output: G235073391
      return match[0];
    } else {
      this.showToast('Tidak ditemukan', 'error');
      return data;
    }
  }
  getDeviceParamFromUrl(url) {
    const parsed = new URL(url);
    return parsed.searchParams.get('device'); // hasil: string terenkripsi
  }
  onScanSuccess(decodedText, decodedResult) {
    const { scanMode } = this.state;
    if (scanMode === 'uid') {
      try {
        const secretKey = '430TPhQy9OoDjGSFAZFb5fkrYJ72tNQr';
        const key = CryptoJS.enc.Utf8.parse(secretKey);

        const decoded = decodeURIComponent(
          this.getDeviceParamFromUrl(decodedText)
        );
        const encryptedWordArray = CryptoJS.enc.Base64.parse(decoded);

        const cipherParams = CryptoJS.lib.CipherParams.create({
          ciphertext: encryptedWordArray,
        });

        const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        });

        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        console.log('Hasil dekripsi:', decryptedText);

        const deviceMap = JSON.parse(decryptedText);
        this.props.GetDeviceId({ uid: deviceMap['uid'] });
        this.setState({ uid: deviceMap['uid'] });
      } catch (error) {
        this.showToast('Gagal mendapatkan UID:', 'error');
        console.error('Gagal dekripsi UID:', error);
        this.setState({ uid: 'Gagal dekripsi, Silahkan Ulangi' });
      }
    } else if (scanMode === 'merchant') {
      this.setState({ merchantId: this.parseEmvQrData(decodedText) });
    }

    this.stopScanner();
  }

  handleValidSubmit = (event, values) => {
    const { uid, merchantId, deviceId } = this.state;
    const payload = {
      uid,
      merchantId,
      deviceId,
    };
    this.setState({
      isLoading: true,
    });
    this.props.LinkMerchantId(payload);
  };

  showToast(msg, toastType) {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
    };

    if (toastType === 'info') toastr.info(msg);
    else if (toastType === 'warning') toastr.warning(msg);
    else if (toastType === 'error') toastr.error(msg);
    else toastr.success(msg);
  }
  render() {
    const { uid, merchantId, deviceId, isScanning, isLoading } = this.state;
    if (safeDeepGet(NAVBAR, ['Bind Merchant', 'view'], 'off') == 'off') {
      return (
        <React.Fragment>
            <style>
              {`
            @keyframes blink {
              0% { opacity: 1; }
              50% { opacity: 0; }
              100% { opacity: 1; }
            }
      
            .blinking {
              animation: blink 2s infinite;
            }
      
            .center-screen {
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              height: 100vh;
              width: 100vw;
              text-align: center;
            }
          `}
            </style>
            <Pages403 className="center-screen" />
        </React.Fragment>
      );
    }
    if (!isMobile) {
      return (
        <React.Fragment>
          <MetaTags>
            <title>Pemindaian UID dan ID Merchant</title>
          </MetaTags>
          <style>
            {`
            @keyframes blink {
              0% { opacity: 1; }
              50% { opacity: 0; }
              100% { opacity: 1; }
            }
      
            .blinking {
              animation: blink 2s infinite;
            }
      
            .center-screen {
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              height: 100vh;
              width: 100vw;
              text-align: center;
            }
          `}
          </style>
          <div className="center-screen">
            <h1 className="blinking" style={{ color: 'red' }}>
              Peringatan
            </h1>
            <h4>
              Fitur scan QR hanya tersedia jika dibuka melalui perangkat{' '}
              <strong>HP / Mobile</strong>.
            </h4>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <MetaTags>
            <title>Pemindaian UID dan ID Merchant</title>
          </MetaTags>

          <div className="page-content">
            <h2>Bindging UID with Merchant ID</h2>

            <div style={{ marginBottom: '1rem' }}>
              <Button
                onClick={() => this.startScanner('uid')}
                disabled={isScanning}
                color="primary"
              >
                Scan UID
              </Button>{' '}
              <Button
                onClick={() => this.startScanner('merchant')}
                disabled={isScanning}
                color="primary"
              >
                Scan Merchant ID
              </Button>{' '}
              <Button
                onClick={() => this.stopScanner()}
                color="danger"
                disabled={!isScanning}
              >
                Stop Scanner
              </Button>
            </div>

            <div
              id={this.videoRegionId}
              style={{ width: '100%', marginBottom: '1rem' }}
            ></div>

            <div>
              <AvForm onSubmit={this.handleValidSubmit}>
                <AvField
                  name="uid"
                  label="UID:"
                  required
                  style={{ width: '100%', marginBottom: '0.5rem' }}
                  readOnly
                  errorMessage="UID tidak boleh kosong"
                  value={uid}
                ></AvField>
                <AvField
                  name="deviceId"
                  label="Business Point:"
                  required
                  errorMessage="Business Point tidak boleh kosong"
                  style={{ width: '100%', marginBottom: '0.5rem' }}
                  readOnly
                  value={deviceId}
                ></AvField>
                <AvField
                  name="merchantId"
                  label="Merchant ID:"
                  required
                  errorMessage="Merchant ID tidak boleh kosong"
                  style={{ width: '100%', marginBottom: '0.5rem' }}
                  readOnly
                  value={merchantId}
                ></AvField>
                <div className="text-center mt-3">
                  {' '}
                  <Button
                    type="submit"
                    disabled={(!uid && !merchantId && !deviceId) || isLoading}
                    color="success"
                  >
                    {isLoading ? 'Loading....' : 'Submit'}
                  </Button>{' '}
                </div>
              </AvForm>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = state => ({
  getDeviceResult: safeGet(state, ['businessPoint', 'get_device_id'], {}),
  linkResult: safeGet(state, ['businessPoint', 'link_merchant_id'], {}),
});

const mapDispatchToProps = dispatch => ({
  GetDeviceId: payload => dispatch(get_device_id(payload)),
  LinkMerchantId: payload => dispatch(link_merchant_id(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScanQRCode);
